
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fIAjW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $afd05c0403d96a25$export$2e2bcd8739ae039);

var $gUvC4 = parcelRequire("gUvC4");

var $9Dhvc = parcelRequire("9Dhvc");

var $1ilzu = parcelRequire("1ilzu");

var $6uWhG = parcelRequire("6uWhG");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");

var $4kMB4 = parcelRequire("4kMB4");

var $7hVvO = parcelRequire("7hVvO");

var $bBtQo = parcelRequire("bBtQo");

var $aV23b = parcelRequire("aV23b");

var $iYKap = parcelRequire("iYKap");

var $7jTnu = parcelRequire("7jTnu");

var $f61JF = parcelRequire("f61JF");
const $afd05c0403d96a25$var$MAX_ATTEMPTS = 3;
class $afd05c0403d96a25$var$RetriedError extends Error {
    constructor(retryErrors = []){
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        super((0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(retryErrors).message);
        this.previousErrors = (0, (/*@__PURE__*/$parcel$interopDefault($gUvC4)))(retryErrors);
    }
}
const $afd05c0403d96a25$var$getCategories = async (projectKey, failedAttempts = [])=>{
    try {
        const data = await (0, $1Ozm9.default)(`/rest/servicedesk/1/servicedesk/${projectKey}/queues/categories?operation=fetchQueueCategories`);
        (0, $6uWhG.setMark)((0, $4kMB4.prefetchApiReadyMark));
        return (0, $f61JF.transformRestData)(data, projectKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraServicedeskQueuesNavigationItemsResource', error.message, {
            statusCode: error.statusCode,
            retryCount: failedAttempts.length
        });
        (0, $gYnSx.default)({
            meta: {
                id: 'jiraServicedeskQueuesNavigationItemsResource',
                packageName: 'jiraSpa'
            },
            error: error,
            attributes: {
                retryCount: failedAttempts.length
            }
        });
        failedAttempts.push(error);
        if (failedAttempts.length >= $afd05c0403d96a25$var$MAX_ATTEMPTS || !(error.statusCode >= 500)) throw new $afd05c0403d96a25$var$RetriedError(failedAttempts);
        return $afd05c0403d96a25$var$getCategories(projectKey, failedAttempts);
    }
};
const $afd05c0403d96a25$var$getData = ({ match: match, query: query }, { tenantContext: tenantContext })=>{
    // Early exit on these cases and return a valid response. We don't want to flood sentry.
    if (!(0, $aV23b.checkAuthentication)(tenantContext)) throw (0, $7hVvO.createResourceError)({
        component: 'spa.view.routes.servicedesk.queues.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    // Resource is shared with non-JSM or non-JCS projects, so invoke initial RRR state on missing JSM or JCS license
    if ((0, $7jTnu.fg)('jcs_project_type_m3')) {
        if (!(0, $iYKap.checkLicense)(tenantContext, 'servicedesk') && !(0, $iYKap.checkLicense)(tenantContext, 'customerservice')) return null;
    } else if (!(0, $iYKap.checkLicense)(tenantContext, 'servicedesk')) return null;
    // projectKey from url path/query or browse/{issueKey}
    const projectKey = (0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match.params, 'issueKey', '')?.split('-')[0];
    if (projectKey == null) return null;
    return $afd05c0403d96a25$var$getCategories(projectKey);
};
var $afd05c0403d96a25$export$2e2bcd8739ae039 = $afd05c0403d96a25$var$getData;

});
parcelRegister("gUvC4", function(module, exports) {

var $1FqKq = parcelRequire("1FqKq");

var $c9FP3 = parcelRequire("c9FP3");
/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */ function $c4fa65feb81e9765$var$dropRight(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) return [];
    n = guard || n === undefined ? 1 : $c9FP3(n);
    n = length - n;
    return $1FqKq(array, 0, n < 0 ? 0 : n);
}
module.exports = $c4fa65feb81e9765$var$dropRight;

});

parcelRegister("4kMB4", function(module, exports) {
$parcel$export(module.exports, "appBundleReadyMark", () => $2b841d37299dd740$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $2b841d37299dd740$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $2b841d37299dd740$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $2b841d37299dd740$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $2b841d37299dd740$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $2b841d37299dd740$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $2b841d37299dd740$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $2b841d37299dd740$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $2b841d37299dd740$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $2b841d37299dd740$export$4eb8d44ddb14424a);


var $dNyX9 = parcelRequire("dNyX9");
const $2b841d37299dd740$export$7e50945a65dd40e = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$ff834eccc35b9089));
const $2b841d37299dd740$export$17cbe723d23101d8 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$86b05e34d462ead8));
const $2b841d37299dd740$export$887fadb22e7c7735 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$d6a604a7d9a390fb));
const $2b841d37299dd740$export$bd099c0a906f4b3f = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$3ae43cc1782d058f));
const $2b841d37299dd740$export$d23ef9e7633e30e7 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$363f6703ffa600be));
const $2b841d37299dd740$export$319da6d901948a6d = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$e87b74567b79c8));
const $2b841d37299dd740$export$f0b6622cdc5c7e4f = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$99fe642459a8b02));
const $2b841d37299dd740$export$37e82663aa1e79a8 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$ab1f5705fc8e0571));
const $2b841d37299dd740$export$21146514eacceb12 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$8c3a9046da692c35));
const $2b841d37299dd740$export$4eb8d44ddb14424a = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$5aa497d1efdcc5bf));

});
const $2e47af044bce450a$export$56940a9488e85199 = 'jira.fe.spa-';
const $2e47af044bce450a$export$45c4b6bf7935c69a = `${$2e47af044bce450a$export$56940a9488e85199}start`;
const $2e47af044bce450a$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $2e47af044bce450a$export$ff834eccc35b9089 = 'appBundleReady';
const $2e47af044bce450a$export$86b05e34d462ead8 = 'prefetchApiReady';
const $2e47af044bce450a$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $2e47af044bce450a$export$3ae43cc1782d058f = 'jswRenderStart';
const $2e47af044bce450a$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $2e47af044bce450a$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $2e47af044bce450a$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $2e47af044bce450a$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $2e47af044bce450a$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $2e47af044bce450a$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $2e47af044bce450a$export$99c08ec92759c71c = 'tti-raf-mark';
const $2e47af044bce450a$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("7hVvO", function(module, exports) {
$parcel$export(module.exports, "createResourceError", () => $57ba68f5ed9efef2$export$13487d18466bc8a5);

var $eSnSE = parcelRequire("eSnSE");
class $57ba68f5ed9efef2$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $57ba68f5ed9efef2$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $57ba68f5ed9efef2$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});

parcelRegister("aV23b", function(module, exports) {
$parcel$export(module.exports, "checkAuthentication", () => $1d4b19068776b455$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $1d4b19068776b455$export$e9b9096e887386fe);

var $eJOHy = parcelRequire("eJOHy");

var $lvKO5 = parcelRequire("lvKO5");

var $5ya7R = parcelRequire("5ya7R");
const $1d4b19068776b455$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $1d4b19068776b455$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvKO5.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($1d4b19068776b455$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5ya7R.RedirectToLoginPage), null);
    });

});
parcelRegister("5ya7R", function(module, exports) {
$parcel$export(module.exports, "RedirectToLoginPage", () => $3692ea1fd0794252$export$938182bd3fddc3a8);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
var $95O7y = parcelRequire("95O7y");
var $gCY1z = parcelRequire("gCY1z");

var $7jTnu = parcelRequire("7jTnu");

var $gr8eh = parcelRequire("gr8eh");
const $3692ea1fd0794252$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$3692ea1fd0794252$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $3692ea1fd0794252$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $gCY1z.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $95O7y.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    if ((0, $7jTnu.fg)('jfp-magma-adjust-redirect-login-logic')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gr8eh.default), {
        url: path
    });
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3692ea1fd0794252$export$3da29de62ed7a388, {
        to: path
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: path
    });
};

});
parcelRegister("gr8eh", function(module, exports) {
$parcel$export(module.exports, "default", () => $afdbf783998da05f$export$2e2bcd8739ae039);

var $gRw8I = parcelRequire("gRw8I");
const $afdbf783998da05f$var$FullPageRedirect = ({ url: url })=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};
var $afdbf783998da05f$export$2e2bcd8739ae039 = $afdbf783998da05f$var$FullPageRedirect;

});



parcelRegister("iYKap", function(module, exports) {
$parcel$export(module.exports, "checkLicense", () => $53e7d1c0d26ba27f$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $53e7d1c0d26ba27f$export$944be0b3bf2a6feb);

var $eJOHy = parcelRequire("eJOHy");

var $lvKO5 = parcelRequire("lvKO5");
const $53e7d1c0d26ba27f$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess',
    customerservice: 'hasCustomerServiceAccess'
};
const $53e7d1c0d26ba27f$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$53e7d1c0d26ba27f$var$appPermissionMapper[type]]);
const $53e7d1c0d26ba27f$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvKO5.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $53e7d1c0d26ba27f$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

parcelRegister("f61JF", function(module, exports) {
$parcel$export(module.exports, "transformRestData", () => $1af8aafa38f7a1b1$export$40da6ae06b8b332e);
const $1af8aafa38f7a1b1$export$40da6ae06b8b332e = ({ categories: categories }, projectKey)=>// @ts-expect-error(PARTIAL_RECORD) TS2740 - Type 'CategorizedQueueRestItem' is missing the following properties from type 'CategorizedQueueData': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    categories.reduce(// @ts-expect-error(PARTIAL_RECORD) TS2345 - Argument of type '(acc: CategorizedQueueData, { key, queues, ...rest }: CategorizedQueueRestItem) => CategorizedQueueData & { [x: string]: { queues: { category: ItsmPractice; count: undefined; projectKey: string; lastRefreshedTime: number; ... 9 more ...; canBeHidden?: boolean | undefined; }[]; iconUrl: string; name: string; order: n...' is not assignable to parameter of type '(previousValue: Record<string, any>, currentValue: CategorizedQueueRestItem, currentIndex: number, array: CategorizedQueueRestItem[]) => Record<...>'.
    (acc, { key: key, queues: queues, ...rest })=>Object.assign(acc, {
            [key]: {
                ...rest,
                queues: queues.map((queue)=>({
                        ...queue,
                        category: key,
                        // We unset the count as the API end-point will always return 0 and we want
                        // to differentiate between no count data and 0 count.
                        // Count data is provided by nav-items end point.
                        count: undefined,
                        projectKey: // Project key is sent as '_UNUSED' by the end-point. We populate it here
                        // so we can have a complete data set
                        projectKey,
                        lastRefreshedTime: 0,
                        shouldSkipIssueCountRefresh: false
                    }))
            }
        }), {});

});



//# sourceMappingURL=async-resource-servicedesk-queues-nav-items.91c5b9d0.js.map
